import { ChainId } from '@pancakeswap/sdk'
import { getContract } from 'utils/contractHelpers'

import { getNftPoolsConfig } from '../constants'
import smartChefNftABI from '../abis/ISmartChefNFT.json'

interface Params {
  chainId?: ChainId
  sousId: number
  provider: any
}

export function getNftPoolContractBySousId({ chainId, sousId, provider }: Params) {
  if (!chainId) {
    return null
  }

  const pools = getNftPoolsConfig(chainId)
  const pool = pools?.find((p) => p.sousId === Number(sousId))
  if (!pool) {
    return null
  }
  const { contractAddress } = pool

  return getContract({
    abi: smartChefNftABI,
    address: contractAddress,
    signer: provider,
  })
}
